import Instance from "../../../../Axios";

// New Actions for the app

const GetObrasAHDProjetosTotais = () => async (dispatch) => {
  await Instance()
    .get(`/construcoes/obras/ahd/projetosTotais`)
    .then(({ data }) => {
      // console.log(data);
      dispatch({
        type: "GET_OBRAS_AHD_PROJETOS_TOTAIS",
        payload: data.yData[0].total,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetObrasAHDProjetosTotais;
